import React, { Component } from 'react';
import PropTypes from 'prop-types';

// import Breadcrumbs from 'react-router-dynamic-breadcrumbs';
import { Redirect } from 'react-router-dom';

import Collection from 'components/Collection';
import ImageCollection from 'components/ImageCollection';
import VideoCollection from 'components/VideoCollection';

import APIHandler from 'config/APIHandler';
import DataHandler from 'config/DataHandler';
import StorageHandler from 'config/StorageHandler';

import { storageKeys } from 'settings';

export default class CollectionView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      collection: [],
      escaped: false,
    };

    this.onEsc = this.onEsc.bind(this);
  }

  UNSAFE_componentWillMount() {
    const { match: url } = this.props;
    document.addEventListener('keydown', this.onEsc);
    if (url) {
      StorageHandler.load(storageKeys.lang).then((lang) => {
        const locale = `${lang.langFile.toLowerCase()}-${lang.langFile
          .toUpperCase()
          .replace('PT', 'BR')
          .replace('ES', '41')
          .replace('KO', 'KR')}`;

        DataHandler.matchAppId().then((id) => {
          const appId = id;
          if (url.params.category === 'images') {
            APIHandler.getImages(appId).then((res) => this.setState({ collection: res.items }));
          } else if (url.params.category === 'videos') {
            DataHandler.checkKey(storageKeys.videos, APIHandler.getVideos(appId)).then(({ items }) => {
              const newItems = {};
              Object.keys(items).forEach((key) => {
                const [firstItem] = items[key];
                const {
                  chapter: { chapterNumber },
                } = firstItem;
                newItems[chapterNumber] = items[key];
              });
              this.setState({ collection: newItems });
            });
          } else if (url.params.category === 'videoLibrary') {
            DataHandler.checkKey(storageKeys.videoLibrary, APIHandler.getVideos(appId)).then(({ items }) => {
              const newItems = {};
              Object.keys(items).forEach((key) => {
                const [firstItem] = items[key];
                const {
                  chapter: { chapterNumber },
                } = firstItem;
                newItems[chapterNumber] = items[key];
              });
              this.setState({ collection: newItems });
            });
          } else {
            APIHandler.getNamedCollection(url.params.category.replace(/-/g, ' '), appId, locale).then((res) =>
              this.setState({ collection: res.items }),
            );
          }
        });
      });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onEsc);
  }

  onEsc(e) {
    if (e.key === 'Escape') {
      this.setState({ escaped: true });
    }
  }

  render() {
    const { escaped, collection } = this.state;

    const {
      match: { url, params },
    } = this.props;
    const { videoId } = params;

    const redirPath =
      videoId !== undefined ? url.substring(0, url.lastIndexOf('/')).lastIndexOf('/') : url.lastIndexOf('/');

    const { pathname } = window.location;
    const isSell = pathname.includes('/sell');

    return (
      <div className="collection__Container">
        <div className={`backgroundImage ${isSell ? 'sell' : ''}`} />
        <div className="collection__Background--overlay" />

        {url.split('/').slice(-1).pop() === 'videos' &&
          Object.values(collection).map((chapter) => (
            <VideoCollection key={chapter[0].chapter.chapterNumber} chapterCollection={chapter} />
          ))}
        {url.split('/').slice(-1).pop() === 'images' &&
          Object.values(collection).map((chapter) => (
            <ImageCollection key={chapter[0].chapter.chapterNumber} chapterCollection={chapter} />
          ))}
        {url.split('/').slice(-1).pop() === 'videoLibrary' &&
          Object.values(collection).map((chapterVideos) => (
            <VideoCollection key={chapterVideos[0].chapter.chapterNumber} chapter={chapterVideos} />
          ))}

        {url.split('/').slice(-1).pop() === 'image-library' &&
          Object.values(collection).map((col) => (
            <div className="brochures">
              <Collection key={col[0].pageID} content={col} header="Image Library" />
            </div>
          ))}

        {url.split('/').slice(-1).pop() !== 'images' &&
          url.split('/').slice(-1).pop() !== 'videos' &&
          url.split('/').slice(-1).pop() !== 'image-library' &&
          Object.keys(collection)
            .filter((key) => !!collection[key][0])
            .map((key) => (
              <div className={`brochures ${url.split('/').slice(-1).pop()}`}>
                <Collection key={collection[key][0].pageID} content={collection[key]} header={key} />
              </div>
            ))}

        {escaped && <Redirect to={url.substring(0, redirPath)} />}
      </div>
    );
  }
}

CollectionView.propTypes = {
  match: PropTypes.shape().isRequired,
};
